import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { Card } from "antd";
import { DEFAULT_FILTER_CALC_RECORDS_QUERY_PARAMS } from "../api";
import { CalcRecordsListFilterView } from "../components/views/CalcRecordsListFilterView";
import { CalcRecordsListTableView } from "../components/views/CalcRecordsListTableView";
import { CalcRecordFilterPageRequest } from "../types";

export const CalcRecordsContainer = () => {
  const searchParams = useFilterSearchParams<CalcRecordFilterPageRequest>({
    params: ["operationType", "calcType", "createdAtMin", "createdAtMax"],
    defaultQueryParamsObject: DEFAULT_FILTER_CALC_RECORDS_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <CalcRecordsListFilterView searchParams={searchParams} />

      <Card className="card-box">
        <CalcRecordsListTableView searchParams={searchParams} />
      </Card>
    </ContentWrapper>
  );
};
